import forEach from "lodash/forEach";
import isObject from "lodash/isObject";

export default function flattenObject(object) {
  const result = {};
  function flatten(obj, prefix = "") {
    forEach(obj, (value, key) => {
      if (isObject(value)) {
        flatten(value, `${prefix}${key}.`);
      } else {
        result[`${prefix}${key}`] = value;
      }
    });
  }
  flatten(object);
  return result;
}
